/* eslint-disable react/prop-types */
/* eslint react/jsx-filename-extension: "off" */

// dateTransform
// shortDateTransform
// dateByTimezoneTransform
// starIconTransform
// featuredIconTransform
// predictiveHeaderTransform
// countryTransform
// infoDotTransform
// lagTransform
// createdByTransform
// sourceTransform
// tagTransform
// trashcanTransform
// flameIconTransform
// trashcanForUserTransform
// sharesTransform
// typeTransform
// typeIconTransform
// changeHeaderTransform
// confidenceHeaderTransform
// changeTransform
// confidenceTransform
// addLineHeightTransform
// sortChange
// sortConfidence

import React from "react";
import moment from "moment";
import _ from "underscore";
import styled from "styled-components";
import twitterLogo from "../../assets/images/svg/twitter_logo.svg";
import defaultAccount from "../../assets/images/svg/default-account.svg";
import telegramLogo from "../../assets/images/svg/telegram_logo.svg";
import wechatLogo from "../../assets/images/svg/wechat_logo.svg";
import weiboLogo from "../../assets/images/svg/weibo_logo.svg";
import vars from "@exo/narrative-tracker-variables";
import { formatPosition } from "@exo/helpers";

import {
	Broadcast,
	Flame,
	InfoDot,
	LightUI,
	MapPin,
	Newspaper,
	Pencil,
	PlayCircle,
	SmallFlame,
	Star,
	Synopsis,
	TinyFlame,
	Trash,
} from "@exo/icons";
import { clampOverflowsById, countryLookup } from "lib/helpers/helpers.js";
import { unintelligibleTitle } from "lib/helpers/textHelpers.js";
import formTweetString from "lib/helpers/formTweetString.js";

export const IconBox = styled.span`
	display: block;
	height: ${(props) => (props.boxSize ? props.boxSize : 16)}px;
	width: ${(props) => (props.boxSize ? props.boxSize : 16)}px;
	margin: ${(props) => (props.margin || "0 auto")};
	opacity: ${(props) => ((props.opacity || props.opacity === 0) ? props.opacity : 1)};
`;
export const CountryBox = styled.span`
	display: block;
	height: ${(props) => (props.boxSize ? props.boxSize : 16)}px;
	margin: 0 auto;
`;
const IconTargetBox = styled(IconBox)`
	opacity: 0.5;
	&:hover {
		opacity: 1;
	}
`;
export const ConfidenceBox = styled.span`
	display: block;
	height: 14px;
	width: 33px;
	margin: 0 auto;
`;
export const ConfidenceBlock = styled.span`
	display: inline-block;
	height: 10px;
	width: 4px;
	margin: 0 1px;
	background-color: ${(props) => props.bgColor};
	opacity: ${(props) => (props.active ? 1 : 0.2)};
`;
export const CenterIt = styled.span`
	display: block;
	width: 100%;
	margin-left: auto;
	margin-right: auto;
	max-width: ${(props) => (props.theWidth ? `${props.theWidth}px` : "100%")};
	text-align: center;
`;
export const RightAlign = styled(CenterIt)`
	text-align: right;
`;
const BarBox = styled.span`
	display: block;
	position: absolute;
	width: 44px;
	height: 6px;
	left: calc(50% - 25px);
	bottom: 2px;
	background-color: ${(props) => props.bgColor};
`;
const Bar = styled.span`
	display: block;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	width: ${(props) => props.percentage}%;
	background-color: ${(props) => props.bgColor};
`;
const NarrativeBarBox = styled(BarBox)`
	left: calc(50% - 30px); /* half of width + right padding (15px)  */
`;
const Higher = styled.span`
	line-height: 150%;
	span,
	a {
		color: ${(props) => props.linkColor};
		${vars.mainfontBold};
	}
`;
export const ThreeLinesMax = styled.span`
	${(props) => (props.bold ? vars.mainfontBlack : vars.mainfont)};
	display: inline-block;
	font-size: 13px;
	line-height: 150%;
	max-height: 57px;
	overflow: hidden;
`;
export const Clamp = styled.span`
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
`;
const SearchName = styled(Higher)`
	${(props) => (props.bold ? vars.mainfontBlack : vars.mainfont)};
`;

const UserCard = styled.span`
	display: block;
	min-height: 40px;
	padding: 5px 0 5px 40px;
	position: relative;
`;
const Avatar = styled.img`
	border-radius: 50%;
	display: block;
	height: 30px;
	left: 0;
	position: absolute;
	top: 5px;
	width: 30px;
`;
const UserName = styled.span`
	${vars.mainfontBold};
	color: ${(props) => props.textColor};
	display: block;
	font-size: 14px;
	overflow-wrap: break-word;
`;
const ScreenName = styled.span`
	${vars.mainfont};
	color: ${(props) => props.textColor};
	display: block;
	font-size: 12px;
	margin-top: 2px;
	overflow-wrap: break-word;
`;

const GlobalWrapper = styled.div`
	background-color: ${(props) => (props.global ? props.bgColor : "transparent")};
	&:hover {
		background-color: ${(props) => (props.global ? props.hoverColor : "transparent")};
	}
	& > div > div {
		background-color: ${(props) =>
			props.global ? props.checkboxColor : "breakOnThisLine"}!important; /* This is the most hack line of code I've ever written */
	}
`;

const SocialIcon = styled.span`
	position: absolute;
	height: ${(props) => (props.type === "WeChatPost" ? "20px;" : "16px;")}
	width: ${(props) => (props.type === "WeChatPost" ? "20px;" : "16px;")}
	left: -8px;
	z-index: 1000;
	background-image: url(${(props) => props.icon});
	background-repeat: no-repeat;
	background-size: contain;
`;

const fullCountryName = (abv) => {
	let fullName = abv;

	switch (abv) {
		case "EE":
			fullName = "The Republic of Estonia";
			break;
		case "LV":
			fullName = "The Republic of Latvia";
			break;
		case "MD":
			fullName = "The Republic of Moldova";
			break;
		case "LT":
			fullName = "The Republic of Lithuania";
			break;
		case "RU":
			fullName = "The Russian Federation";
			break;

		default:
			fullName = abv;
	}

	return fullName;
};

const socialMediaPlatformIcon = (type) => {
	let logo = null;
	switch (type) {
		case "Tweet":
			logo = twitterLogo;
			break;
		case "TelegramPost":
			logo = telegramLogo;
			break;
		case "Wechat":
			logo = wechatLogo;
			break;
		case "Weibo":
			logo = weiboLogo;
			break;
		default:
			logo = twitterLogo;
			break;
	}
	return logo;
};

// Table returns cell and row in params

// expects ms from the epoch as a string
export const dateTransformForceMoment = (params) => {
	const { cell } = params;
	return !cell ? "--" : moment(Number(cell)).format("MMM D, YYYY");
};
export const formatCurrencyTransform =(params) => {
	const { cell } = params;
    return !cell
	? "--"
	: _.isString(cell)
	? parseFloat(cell).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : cell.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}
export const dateTransform = (params) => {
	const { cell } = params;
	return !cell
		? "--"
		: _.isString(cell)
		? cell
		: moment(cell * 1000)
				.utc()
				.format("MMM D, YYYY");
};

const DateC = styled.span`
	display: block;
	position: absolute;
	height: 26px;
	width: 60px;
	top: 50%;
	left: -7px;
	margin-top: -13px;
	padding: 6px 0;
	border-radius: 4px;
	font-size: 13px;
	${vars.mainfontBold};
	color: #000;
	background-color: ${(props) => props.backgroundColor};
	text-align: center;
`;
export const shortDateTransform = (params) => {
	const date = params.cell;
	const { context } = params;
	return (
		<DateC backgroundColor={context.projectTheme ? context.projectTheme.contentDate : vars.blueGrey_3}>
			{moment(date * 1000)
				.utc()
				.format("MMM D")}
		</DateC>
	);
};

const LongDate = styled(DateC)`
	width: 85px;
	margin-top: -13px;
`;
export const longDateTransform = (params) => {
	const date = params.cell;
	const { context } = params;
	return (
		<LongDate backgroundColor={context.projectTheme ? context.projectTheme.contentDate : vars.blueGrey_3}>
			{moment(date * 1000)
				.utc()
				.format("MMM D, YYYY")}
		</LongDate>
	);
};

// just changes the string
export const dateByTimezoneTransform = (params) => {
		const { cell, context } = params;
		const { timezone, granularity } = context;
		const showMinutes = granularity === "1h" || granularity === "15m"; // w/o granularity, defaults to false
	try {
		const includesOffset = cell.includes("+") || cell.includes("Z");
		const updatedCell = includesOffset ? cell : `${cell}+0000`;
		const minuteInMs = 60 * 1000;
		const minutes = moment(updatedCell).format("m");
		const seconds = moment(updatedCell).format("s");
		const invisibleSeconds = Number(minutes) < 1 && Number(seconds) > 0;
	
		// Doing this slightly awkwardly so that it's exactly the same as the Graph
		const msOffset = timezone.offset * minuteInMs;
		const utcDate = moment(params.cell).format("x");
		const date = moment(Number(utcDate) + msOffset + (invisibleSeconds ? minuteInMs : 0)); // rounding the display up by a minute, since it doesn't show seconds
	
		// This must be set back to .utc() so that the offset works. Otherwise, moment will set it to the local timezone
		// let displayDate = timezone.displayInSourceTimeZone ? date.utc() : date.local();
		let displayDate = date.utc();
		return displayDate.format(showMinutes ? "D MMM H:mm" : "MMM Do, YYYY");
	} 
	catch (err){
		console.warn(err)
		return moment(cell).format(showMinutes ? "D MMM H:mm" : "MMM Do, YYYY")
	}
};

export const socialUserTransform = (params) => {
	const { row, context, cell } = params;
	const { darkUI } = context;
	const { screenName, profileImageLink } = row;
	return (
		<UserCard>
			<SocialIcon icon={socialMediaPlatformIcon(row["__typename"])} type={row["__typename"]} />
			<Avatar src={profileImageLink || defaultAccount} alt="" />
			<UserName textColor={darkUI ? vars.sky_0_5 : vars.text_3}>{cell}</UserName>
			<ScreenName textColor={darkUI ? vars.sky_2 : vars.text_1}>{`@${screenName}`}</ScreenName>
		</UserCard>
	);
};

export const socialTextTransform = (params) => {
	const { row, context, cell } = params;
	const { darkUI, distractionFreeDeveloperMode } = context;
	const tweetString = distractionFreeDeveloperMode
		? unintelligibleTitle()
		: formTweetString({
				text: cell,
				userMentions: row.userMentions || [],
				hashtags: row.hashtags || [],
				urls: row.urls || [],
				noLinks: true,
		  });
	return (
		<Higher
			className="translate"
			linkColor={darkUI ? vars.cerulean_1 : vars.cerulean_2}
			dangerouslySetInnerHTML={{ __html: tweetString }}
		/>
	);
};

export const starIconTransform = (params) => {
	const { row, context } = params;
	return (
		<IconBox
			onMouseEnter={(event) => context.openFeaturedTooltip(formatPosition(event.target), row)}
			onMouseLeave={() => context.closeFeaturedTooltip()}
			boxSize={14}
		>
			<Star fill="#7c8faf" scale={0.8} />
		</IconBox>
	);
};

export const featuredIconTransform = (params) => {
	const { cell, context, row } = params;
	if (cell) {
		return (
			<IconBox
				onMouseEnter={(event) => context.openFeaturedTooltip(formatPosition(event.target), row)}
				onMouseLeave={() => context.closeFeaturedTooltip()}
				boxSize={14}
			>
				<Star fill="#7c8faf" scale={0.8} />
			</IconBox>
		);
	} else {
		return " ";
	}
};

const Header = styled.span`
	text-decoration: underline dotted;
`;
export const predictiveHeaderTransform = (params) => {
	const { cell, context, row } = params;
	const text = `How predictive is this time series of CBP Interdiction Data, at a ${row.id.slice(0, -1)} week offset.`;
	if (cell) {
		return (
			<Header
				onMouseEnter={(event) => context.openPredictiveHeaderTooltip({ position: formatPosition(event.target), text })}
				onMouseLeave={() => context.closePredictiveHeaderTooltip()}
			>
				{cell}
			</Header>
		);
	} else {
		return " ";
	}
};

export const countryTransform = (params) => {
	const { cell, context } = params;
	if (cell) {
		return (
			<CountryBox
				onMouseEnter={(event) => context.openCountryTooltip(formatPosition(event.target), fullCountryName(cell))}
				onMouseLeave={() => context.closeCountryTooltip()}
				boxSize={14}
			>
				{countryLookup(cell)}
			</CountryBox>
		);
	} else {
		return " ";
	}
};

export const infoDotTransform = (params) => {
	const { row } = params;
	if (row.info) {
		return <InfoDot fill="#85a7d5" />;
	} else {
		return " ";
	}
};

export const lagTransform = (params) => {
	const { cell } = params;

	// weeks if over 48 days
	if (cell === null || typeof cell === "undefined" || cell === false) {
		return cell; // non 0 negatives are handled later & need to still be negative.
		// } else if (cell < 49) {
		// 	return `${cell} days`;
	} else {
		const weeks = Math.ceil(cell / 7);
		return `${weeks} week${weeks > 1 ? "s" : ""}`;
	}
};

export const createdByTransform = (params) => {
	const { cell } = params;
	return cell ? cell.charAt(0).toUpperCase() + cell.slice(1) : "";
};

const Source = styled.span`
	${vars.mainfontBold};
	color: ${(props) => props.color};
	word-break: break-word;
`;
export const sourceTransform = (params) => {
	const { cell, context } = params;
	const { darkUI } = context;
	return <Source color={darkUI ? vars.sky_1 : vars.grey_4}>{cell}</Source>;
};

const TitleSpan = styled.span`
	margin-right: 10px;
	line-height: 130%;
`;
const TagBox = styled.span`
	display: inline-block;
	padding-right: 2px;
	text-align: left;
`;
const Tag = styled.span`
	display: inline-block;
	position: relative;
	height: 10px;
	width: ${(props) => (props.colorBlindMode ? 40 : 10)}px;
	margin: 0 4px;
	border-radius: 2px;
	border: 1px solid ${vars.grey_2};
	z-index: 1;
	transition: width 350ms ease-out 50ms;
`;
const IconTag = styled.span`
	display: inline-block;
	height: 14px;
	width: 14px;
	margin-right: 5px;
	margin-bottom: 1px;
	vertical-align: text-bottom;
`;
export const tagTransform = (params) => {
	const { cell, row, context } = params;
	// console.log("tags", row.tags);

	return (
		<span>
			<TitleSpan dangerouslySetInnerHTML={{ __html: cell }} />
			<TagBox>
				{row.tags &&
					row.tags.map((tag) => {
						return (
							<Tag
								key={`contentLink__tag-${row.uuid || row.id}-${tag.id}`}
								className={tag.color && (tag.color.colorblind || tag.color.colorblindstripes)}
								colorBlindMode={context.colorBlindMode}
								style={{
									backgroundColor: context.darkUI ? tag.color && tag.color.dark : tag.color && tag.color.light,
								}}
								onMouseEnter={(event) => context.openTagTooltip(formatPosition(event.target), tag)}
								onMouseLeave={() => context.closeTagTooltip()}
							/>
						);
					})}
				{row.video && (
					<IconTag
						onMouseEnter={(event) => context.openVideoTooltip(formatPosition(event.target), row)}
						onMouseLeave={() => context.closeVideoTooltip()}
					>
						<PlayCircle fill="#7c8faf" />
					</IconTag>
				)}
				{row.synopsis && (
					<IconTag
						onMouseEnter={(event) => context.openSynopsisTooltip(formatPosition(event.target), row)}
						onMouseLeave={() => context.closeSynopsisTooltip()}
					>
						<Synopsis fill="#7c8faf" />
					</IconTag>
				)}
				{row.socialGraph && (
					<IconTag
						onMouseEnter={(event) => context.openSocialGraphTooltip(formatPosition(event.target), row)}
						onMouseLeave={() => context.closeSocialGraphTooltip()}
					>
						<LightUI fill="#7c8faf" />
					</IconTag>
				)}
			</TagBox>
		</span>
	);
};

export const trashcanTransform = (params) => {
	const { context } = params;
	const { darkUI } = context;
	return (
		<IconTargetBox>
			<Trash fill={darkUI ? vars.sky_2 : vars.text_2} />
		</IconTargetBox>
	);
};
export const pencilTransform = (params) => {
	const { context } = params;
	const { darkUI } = context;
	return (
		<IconTargetBox>
			<Pencil fill={darkUI ? vars.sky_2 : vars.text_2} />
		</IconTargetBox>
	);
};

const FlameBox = styled.span`
	display: block;
	width: 20px;
	height: 20px;
	margin-left: -6px;
	svg {
		height: 100%;
		width: 100%;
	}
`;
export const flameIconTransform = (params) => {
	const { row, context } = params;

	if (row.shares > context.hotArticleLimit.hot) {
		return (
			<FlameBox
				onMouseEnter={(event) => context.openSharesTooltip(formatPosition(event.target), row)}
				onMouseLeave={() => context.closeSharesTooltip()}
			>
				{row.shares > context.hotArticleLimit.hottest ? (
					<Flame fill={vars.persimmon_2} />
				) : row.shares > context.hotArticleLimit.hotter ? (
					<SmallFlame fill={vars.tangelo_1} scale={0.9} />
				) : (
					<TinyFlame fill={vars.yellow_2} scale={0.7} />
				)}
			</FlameBox>
		);
	} else {
		return "";
	}
};

export const trashcanForUserTransform = (params) => {
	const { row } = params;
	if (row.perspective === "Reaction") {
		// if (row.createdBy === "user") {
		return <Trash fill="#85a7d5" />;
	} else {
		return " ";
	}
};

const Shares = styled.span`
	display: block;
	text-align: center;
	${vars.numberfont};
`;
export const sharesTransform = (params) => {
	const { cell } = params;
	return <Shares>{cell || cell === 0 ? Number(cell).toLocaleString() : "--"}</Shares>;
};

export const typeTransform = (params) => {
	const { row } = params;
	return row.displayType || row.type;
};

// TODO: Pass icon specific props to IconBox if necessary
export const typeIconTransform = (params) => {
	const { row } = params;
	if (row.type === "TV/Radio") {
		return (
			<IconBox>
				<Broadcast fill="#657694" />
			</IconBox>
		);
	} else if (row.type === "Print" || row.type === "article") {
		return (
			<IconBox>
				<Newspaper fill="#657694" />
			</IconBox>
		);
	} else if (row.type === "event") {
		return (
			<IconBox>
				<MapPin fill="#657694" />
			</IconBox>
		);
	} else {
		return "";
	}
};

export const changeHeaderTransform = (params) => {
	const { cell, context, row } = params;
	const text = `Percentage baseline time series changes in the ${cell.toLowerCase()} term when predicted against this time series`;
	if (cell) {
		return (
			<Header
				onMouseEnter={(event) => context.openPredictiveHeaderTooltip({ position: formatPosition(event.target), text })}
				onMouseLeave={() => context.closePredictiveHeaderTooltip()}
				rightAlign
			>
				{cell}
			</Header>
		);
	} else {
		return " ";
	}
};
export const confidenceHeaderTransform = (params) => {
	const { cell, context, row } = params;
	const text = "How accurate is this prediction";
	return (
		<Header
			onMouseEnter={(event) => context.openPredictiveHeaderTooltip({ position: formatPosition(event.target), text })}
			onMouseLeave={() => context.closePredictiveHeaderTooltip()}
		>
			<ConfidenceBox>
				{_.times(5, (number) => {
					return <ConfidenceBlock active={number < 3} bgColor={vars.sky_2} />;
				})}
			</ConfidenceBox>
		</Header>
	);
};

const Text = styled.span`
	color: ${(props) => props.theColor};
	${vars.numberfont};
`;
export const changeTransform = (params) => {
	const { col, row } = params;
	const cell = row[col.id];

	const change = cell && cell.predictiveChange;
	const color = change >= 0 ? vars.grass_1 : vars.tangelo_2;
	if (change) {
		const roundedChange = Math.round(change * 100) / 100;
		return (
			<RightAlign>
				<Text theColor={color}>{`${roundedChange}%`}</Text>
			</RightAlign>
		);
	} else {
		return <RightAlign>--</RightAlign>;
	}
};
export const confidenceTransform = (params) => {
	const { col, context, row } = params;
	const cell = row[col.id];

	if (cell && cell.predictiveImpact) {
		const text = `Confidence score of ${Math.round(cell.predictiveImpact * 100) / 100}`;
		const impact =
			cell.predictiveImpact > 40
				? 5
				: cell.predictiveImpact > 30
				? 4
				: cell.predictiveImpact > 20
				? 3
				: cell.predictiveImpact > 10
				? 2
				: cell.predictiveImpact > 0
				? 1
				: 0;
		return (
			<CenterIt
				onMouseEnter={(event) => context.openPredictiveHeaderTooltip({ position: formatPosition(event.target), text })}
				onMouseLeave={() => context.closePredictiveHeaderTooltip()}
			>
				<ConfidenceBox>
					{_.times(5, (number) => {
						return <ConfidenceBlock active={impact > number} bgColor={vars.sky_2} />;
					})}
				</ConfidenceBox>
			</CenterIt>
		);
	} else {
		return <CenterIt>--</CenterIt>;
	}
};

export const threeLineClampTransform = (params) => {
	const { cell, row, col, context } = params;
	const { global, id } = row;
	const { openGenericTooltip, closeGenericTooltip, tableId } = context;

	const clampId = `${tableId}_threeLineClampTransform_${col.id}_${id || row[col.id]}`;

	const isClamped = openGenericTooltip && clampOverflowsById(clampId);

	return (
		<ThreeLinesMax bold={global && global !== "false"}>
			<Clamp
				id={clampId}
				onBlur={() => isClamped && closeGenericTooltip()}
				onFocus={(event) => isClamped && openGenericTooltip({ text: cell, position: formatPosition(event.target) })}
				onMouseEnter={(event) => isClamped && openGenericTooltip({ text: cell, position: formatPosition(event.target) })}
				onMouseLeave={() => isClamped && closeGenericTooltip()}
				role="button"
				tabIndex={isClamped ? "0" : "-1"}
			>
				{cell}
			</Clamp>
		</ThreeLinesMax>
	);
};

export const socialSearchNameTransform = (params) => {
	const { cell, row } = params;
	const { global } = row;
	return <SearchName bold={global}>{cell}</SearchName>;
};

// cell can be a string, an array of strings, or an array of objects with "name": string
export const showPossibleArrayTransform = (params) => {
	const { cell, row } = params;
	const { global } = row;
	let text = "--";

	if (cell) {
		if (_.isArray(cell)) {
			const arrayOfStrings = _.isString(cell[0]);
			if (arrayOfStrings) {
				text = cell.join(", ");
			} else {
				const namesArr = _.pluck(cell, "name");
				text = namesArr.join(", ");
			}
		} else {
			text = cell;
		}
	}
	return <SearchName bold={global}>{text}</SearchName>;
};

export const addLineHeightTransform = (params) => {
	const { cell } = params;
	return <Higher>{cell}</Higher>;
};

export const dangerouslyAddLineHeightTransform = (params) => {
	const { cell } = params;
	return <Higher dangerouslySetInnerHTML={{ __html: cell }} />;
};

export const percentageTransform = (params) => {
	const { cell, context, row } = params;
	const { darkUI, highlightColor, totalArticles } = context;
	const percentage = cell ? Math.round((cell / totalArticles) * 1000) / 10 : 0;
	const total = cell ? cell.toLocaleString() : 0;

	return (
		<CenterIt>
			{row.floatingRow ? total : `${percentage.toLocaleString()}%`}
			{!row.floatingRow && (
				<BarBox bgColor={darkUI ? vars.charcoal_1_2 : vars.blueGrey_0_5}>
					<Bar bgColor={highlightColor} percentage={percentage} />
				</BarBox>
			)}
		</CenterIt>
	);
};

export const narrativePercentageTransform = (params) => {
	const { cell, row, col, context } = params;
	const { narrativeStatsTotals, highlightColor, darkUI } = context;

	const columnTotal = narrativeStatsTotals[col.id];
	const percentage = cell && columnTotal ? Math.round((cell / columnTotal) * 1000) / 10 : 0;
	const total = cell ? cell.toLocaleString() : 0;

	return (
		<CenterIt>
			{row.floatingRow ? total : `${percentage.toLocaleString()}%`}
			{!row.floatingRow && (
				<NarrativeBarBox bgColor={darkUI ? vars.charcoal_1_2 : vars.blueGrey_0_5}>
					<Bar bgColor={highlightColor} percentage={percentage} />
				</NarrativeBarBox>
			)}
		</CenterIt>
	);
};

const Highlight = styled.span`
	display: inline-block;
	padding-right: 7px;
	&:after {
		content: "";
		position: absolute;
		top: 0;
		bottom: -9px;
		right: 7px;
		left: -1px;
		border-radius: 0 0 3px 3px;
		background-color: ${(props) => props.bgColor || "transparent"};
		opacity: 0.4;
	}
`;
const HeaderHighlight = styled(Highlight)`
	&:after {
		bottom: -18px;
		top: -10px;
		right: 8px;
		left: 0;
		border-radius: 3px 3px 0 0;
	}
`;
const Shadow = styled.span`
	position: absolute;
	top: 0;
	bottom: -9px;
	right: -3px;
	left: -11px;
	overflow: hidden;
	&:after {
		content: "";
		position: absolute;
		top: 0;
		bottom: 0;
		left: 10px;
		right: 10px;
		box-shadow: 0 -4px 8px 2px rgba(0, 0, 0, ${(props) => (props.darkUI ? "0.75" : "0.25")});
	}
`;
const HeaderShadow = styled(Shadow)`
	bottom: -18px;
	right: -2px;
	left: -10px;
	top: -10px;
	&:after {
		box-shadow: 0 6px 8px 2px rgba(0, 0, 0, ${(props) => (props.darkUI ? "0.75" : "0.25")});
	}
`;
const HighlightText = styled.span`
	display: block;
	position: relative;
	line-height: 150%;
	padding-left: 7px;
	z-index: 1;
	color: ${(props) => props.textColor};
	font-weight: 400;
	transform: none;
`;
export const highlightNarrativeHeader = (params) => {
	const { context } = params;
	const { currentTopic, darkUI, highlightColor, textColor } = context;

	const showingTopics = currentTopic.id === "narratives";

	return (
		<HeaderHighlight bgColor={highlightColor}>
			<HighlightText textColor={textColor}>{showingTopics ? "Topic" : "Narrative"}</HighlightText>
			<HeaderShadow darkUI={darkUI} />
		</HeaderHighlight>
	);
};
export const highlightNarrative = (params) => {
	const { cell, context } = params;
	const { darkUI, textColor } = context;
	return (
		<Highlight bgColor={context.highlightColor}>
			<HighlightText textColor={textColor} dangerouslySetInnerHTML={{ __html: cell }} />
			<Shadow darkUI={darkUI} />
		</Highlight>
	);
};

export const boolCellTransform = (params) => {
	const { cell } = params;
	return !cell ? "No" : "Yes";
};


export const topicOrNarrativeTransform = (params) => {
	const { context } = params;
	const { currentTopic } = context;

	const showingTopics = currentTopic.id === "narratives";

	return <Higher>{showingTopics ? "Topic" : "Narrative"}</Higher>;
};

// ------- Sort functions -------
export const sortChange = (params) => {
	const { header, rows } = params;
	return _.sortBy(rows, (row) => {
		const rowItem = row[header.id];
		return rowItem && rowItem.predictiveChange ? rowItem.predictiveChange : -999999;
	});
};
export const sortConfidence = (params) => {
	const { header, rows } = params;
	return _.sortBy(rows, (row) => {
		const rowItem = row[header.id];
		return rowItem && rowItem.predictiveImpact ? rowItem.predictiveImpact : -999999;
	});
};
export const sortDate = (params) => {
	const { header, rows } = params;
	return _.sortBy(rows, (row) => {
		const rowItem = row[header.id];
		return rowItem.padStart(13, "0");
	});
};
export const sortDateStr = (params) => {
	const { header, rows } = params;
	return _.sortBy(rows, (row) => {
		const rowItem = row[header.id];
		try {
			const ms = new Date(rowItem).getTime();
			return ms;
		}
		catch {
			return rowItem;
		}
	});
};

// -------- RowTransforms ---------
export const GlobalSearchTransform = (props) => {
	const { row, context, children, index } = props;
	const { darkUI } = context;
	const { global, isTopicSearch } = row;

	const isEven = index % 2 === 0;

	const topicOdd = darkUI ? vars.viridian_10 : vars.pistachio_20;
	const topicEven = darkUI ? vars.viridian_30 : vars.pistachio_30;
	const topicOddHover = darkUI ? vars.viridian_20 : vars.pistachio_10;
	const topicEvenHover = darkUI ? vars.viridian_40 : vars.pistachio_40;
	const topicCheckbox = darkUI ? vars.viridian_50 : vars.moss_70;

	const notTopicOdd = darkUI ? vars.blackberry_10 : vars.blueGrey_4;
	const notTopicEven = darkUI ? vars.blackberry_30 : vars.blueGrey_6;
	const notTopicOddHover = darkUI ? vars.blackberry_20 : vars.blueGrey_5;
	const notTopicEvenHover = darkUI ? vars.blackberry_40 : vars.blueGrey_7;
	const notTopicCheckbox = darkUI ? "#000000" : vars.grey_3;

	const oddColor = isTopicSearch ? topicOdd : notTopicOdd;
	const evenColor = isTopicSearch ? topicEven : notTopicEven;
	const oddHoverColor = isTopicSearch ? topicOddHover : notTopicOddHover;
	const evenHoverColor = isTopicSearch ? topicEvenHover : notTopicEvenHover;
	const checkboxColor = isTopicSearch ? topicCheckbox : notTopicCheckbox;
	return (
		<GlobalWrapper
			global={global}
			bgColor={isEven ? evenColor : oddColor}
			hoverColor={isEven ? evenHoverColor : oddHoverColor}
			checkboxColor={checkboxColor}
		>
			{children}
		</GlobalWrapper>
	);
};
